// extracted by mini-css-extract-plugin
export default {"footerContainer":"_4BrcrHlyHC5LfIqXC46-3Q=="};